'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBarcodeOutline = function IoIosBarcodeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.5 30v-20h6.3v1.3h-5v17.5h5v1.2h-6.3z m26.3-20h6.2v20h-6.2v-1.2h5v-17.5h-5v-1.3z m-21.3 15v-10h1.3v10h-1.3z m21.3 0v-10h1.2v10h-1.2z m-5 2.5v-15h1.2v15h-1.2z m-11.3 0v-15h1.3v15h-1.3z m5.5-1.2v-12.5h1.3v12.5h-1.3z' })
        )
    );
};

exports.default = IoIosBarcodeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-barcode-outline.js
// module id = 2310
// module chunks = 0